import { render, staticRenderFns } from "./tenderInfoContentPreview.vue?vue&type=template&id=09bc65b2&scoped=true&"
import script from "./tenderInfoContentPreview.vue?vue&type=script&lang=js&"
export * from "./tenderInfoContentPreview.vue?vue&type=script&lang=js&"
import style0 from "./tenderInfoContentPreview.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tenderInfoContentPreview.vue?vue&type=style&index=1&id=09bc65b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bc65b2",
  null
  
)

export default component.exports